// import router from '../../router'
import {
  PATIENT_SEARCH, PATIENT_SEARCH_SUCCESS, PATIENT_SEARCH_FAILURE, PATIENT_SHOW, PATIENT_SHOW_SUCCESS, PATIENT_SHOW_FAILURE, PATIENT_SHOW_CLEAR,
  PATIENT_UPDATE, PATIENT_UPDATE_FAILURE, PATIENT_UPDATE_SUCCESS, PATIENT_UPLOAD_START, SET_PATIENT, SET_PATIENT_SUCCESS, CLEAR_PATIENT_SEARCH_PARAMS,
  PATIENT_SEARCH_LIST, PATIENT_SET_SEL_FLAG, PATIENT_SET_SEL_FLAG_SUCCESS, PATIENT_SET_SEL_FLAG_FAILURE,
  PATIENT_AVATAR_UPLOAD, PATIENT_AVATAR_UPLOAD_FAILURE, PATIENT_AVATAR_UPLOAD_SUCCESS,
  PATIENT_SEARCH_LIST_ENABLE, PATIENT_SEARCH_PATIENT_CODE, PATIENT_SEARCH_PATIENT_CODE_FAILURE, PATIENT_SEARCH_PATIENT_CODE_SUCCESS, CLEAR_PATIENT_CODE,
  PATIENT_CLEAR, PATIENT_NS_REMOVE, PATIENT_NS_REMOVE_FAILURE, PATIENT_NS_REMOVE_SUCCESS
} from './mutation-types'
import constant from '../constant'

export default {
  state: {
    patient: null,
    patients: null,
    patientsDataExists: true,
    patientsCurrentPage: null,
    patientsNextPage: null,
    patientsTotalCount: 0,
    uploader: {
      total: 0,
      current: 0,
      errors: [],
      status: null
    },
    searchParams: null,
    patientCodeList: [],
    notify: ''
  },
  getters: {
    patient: state => {
      return state.patient
    },
    patients: state => {
      return state.patients
    },
    patientsCurrentPage: state => {
      return state.patientsCurrentPage
    },
    patientsNextPage: state => {
      return state.patientsNextPage
    },
    patientsDataExists: state => {
      return state.patientsDataExists
    },
    avatarUploadCounter: state => {
      var counter = state.uploader.current + '/' + state.uploader.total
      if (state.uploader.total === 0) {
        return ''
      } else {
        return counter + '件のアップロードが完了しました。'
      }
    },
    avatarUploadErrors: state => {
      return state.uploader.errors
    },
    avatarUploadStatus: state => {
      return state.uploader.status
    },
    patientsTotalCount: state => {
      return state.patientsTotalCount
    },
    patientSearchParams: state => {
      return state.searchParams
    },
    patientCodeList: state => {
      return state.patientCodeList
    },
    /** 通知 */
    patientNotify: state => {
      return state.notify
    }
  },
  actions: {
    [PATIENT_SEARCH] ({dispatch, state, commit}, params = null) {
      var url = '/patients'
      var data = {}
      var loadparams = true
      var callback = () => {}
      if (params) {
        if (params.url && !params.clear) {
          url = params.url
        }
        if ('callback' in params) {
          callback = params.callback
        }
        if (params.clear) {
          state.patientsDataExists = true // データあり状態で「データが見つかりませんでした」表示を制御
          state.patients = null
          state.patientsCurrentPage = null
          state.patientsNextPage = null
          state.patientsTotalCount = 0
        }
        if ('loadparams' in params) {
          loadparams = params.loadparams
        }
        state.searchParams = params.data
        data = params.data
      }
      dispatch('apiGet', {url: url, data: data, loadparams: loadparams})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(PATIENT_SEARCH_FAILURE, {data: res.data, callback: callback})
          } else {
            commit(PATIENT_SEARCH_SUCCESS, {data: res.data, callback: callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },

    /** 患者検索一覧(有効フラグ指定版) */
    [PATIENT_SEARCH_LIST_ENABLE] ({dispatch, state, commit}, params = {}) {
      var url = '/patient_search/lists'
      var data = {}
      var loadparams = true
      var callback = () => {}
      if (params) {
        if (params.url && !params.clear) {
          url = params.url
        }
        if (params.clear) {
          state.patientsDataExists = true // データあり状態で「データが見つかりませんでした」表示を制御
          state.patients = null
          state.patientsCurrentPage = null
          state.patientsNextPage = null
        }
        if ('loadparams' in params) {
          loadparams = params.loadparams
        }
        if ('callback' in params) {
          callback = params.callback
        }
        state.searchParams = params.data
        data = params.data
      }
      dispatch('apiGet', {url: url, data: data, loadparams: loadparams})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(PATIENT_SEARCH_FAILURE, {data: res.data, callback: callback})
          } else {
            commit(PATIENT_SEARCH_SUCCESS, {data: res.data, callback: callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },

    /** 患者検索一覧 */
    [PATIENT_SEARCH_LIST] ({dispatch, state, commit}, params = {}) {
      var url = '/patient_search'
      var data = {}
      var loadparams = true
      var callback = () => {}
      if (params) {
        if (params.url && !params.clear) {
          url = params.url
        }
        if (params.clear) {
          state.patientsDataExists = true // データあり状態で「データが見つかりませんでした」表示を制御
          state.patients = null
          state.patientsCurrentPage = null
          state.patientsNextPage = null
        }
        if ('loadparams' in params) {
          loadparams = params.loadparams
        }
        if ('callback' in params) {
          callback = params.callback
        }
        state.searchParams = params.data
        data = params.data
      }
      dispatch('apiGet', {url: url, data: data, loadparams: loadparams})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(PATIENT_SEARCH_FAILURE, {data: res.data, callback: callback})
          } else {
            commit(PATIENT_SEARCH_SUCCESS, {data: res.data, callback: callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [SET_PATIENT] ({dispatch, state, commit}, params = null) {
      commit(SET_PATIENT_SUCCESS, params.patient)
    },
    [PATIENT_SHOW] ({dispatch, state, commit}, params = null) {
      var url = '/patients/' + params.patientId
      var callback = () => {}

      dispatch('apiGet', {url: url})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(PATIENT_SHOW_FAILURE, {data: res.data, callback: callback})
          } else {
            commit(PATIENT_SHOW_SUCCESS, {data: res.data, callback: callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [PATIENT_UPLOAD_START] ({state}) {
      state.uploader.status = null
      state.uploader.errors = []
    },
    [PATIENT_UPDATE] ({dispatch, state, commit}, params = null) {
      var url = '/patients/' + params.patientId

      dispatch('apiPatch', {url: url, data: params.data})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(PATIENT_UPDATE_FAILURE, res.data)
          } else {
            commit(PATIENT_UPDATE_SUCCESS, res.data)
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [CLEAR_PATIENT_SEARCH_PARAMS] ({state, commit}, sleep = 0) {
      setTimeout(() => {
        commit(CLEAR_PATIENT_SEARCH_PARAMS)
      }, sleep)
    },
    /** 選択フラグ更新 */
    [PATIENT_SET_SEL_FLAG] ({dispatch, state, commit}, params = {}) {
      var url = '/patient_search'
      var callback = () => {}
      if (params.callback) {
        callback = params.callback
      }

      dispatch('apiPatch', {url: url, data: params.data, loadparams: 'block'})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(PATIENT_SET_SEL_FLAG_FAILURE, {data: res.data, callback: callback})
          } else {
            commit(PATIENT_SET_SEL_FLAG_SUCCESS, {data: res.data, callback: callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    /** アバターの一時保存 */
    [PATIENT_AVATAR_UPLOAD] ({dispatch, state, commit}, params = null) {
      dispatch('apiPatch', {url: '/patients/upload/', data: params.data, loadparams: 'block'})
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(PATIENT_AVATAR_UPLOAD_FAILURE, res.data)
            } else {
              commit(PATIENT_AVATAR_UPLOAD_SUCCESS, {data: res.data, callback: params.callback})
            }
          }
        })
        .catch(error => {
          throw error
        })
    },
    [PATIENT_CLEAR] ({state, commit}, sleep = 0) {
      setTimeout(() => {
        commit(PATIENT_CLEAR)
      }, sleep)
    },
    [PATIENT_SHOW_CLEAR] ({state, commit}, sleep = 0) {
      setTimeout(() => {
        commit(PATIENT_SHOW_CLEAR)
      }, sleep)
    },
    [PATIENT_SEARCH_PATIENT_CODE] ({dispatch, state, commit}, params) {
      var data = params.data
      dispatch('apiGet', {url: '/patients/search_patient_code', data: data})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(PATIENT_SEARCH_PATIENT_CODE_FAILURE, res.data)
          } else {
            commit(PATIENT_SEARCH_PATIENT_CODE_SUCCESS, { data: res.data })
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [CLEAR_PATIENT_CODE] ({state}) {
      state.patientCodeList = []
    },
    [PATIENT_NS_REMOVE] ({dispatch, state, commit}, params) {
      var url = '/patients/ns_remove'

      dispatch('apiGet', {url: url, data: params.data})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(PATIENT_NS_REMOVE_FAILURE, res.data)
          } else {
            commit(PATIENT_NS_REMOVE_SUCCESS, res.data)
          }
        }
      })
      .catch(error => {
        throw error
      })
    }
  },
  mutations: {
    [PATIENT_SEARCH_FAILURE] (state, data) {
      console.log('PATIENT_SEARCH_FAILURE')
      state.patientsDataExists = false // データなし
      if (data.callback) {
        data.callback()
      }
    },
    [CLEAR_PATIENT_SEARCH_PARAMS] ({state}) {
      state.patient = null
    },
    [PATIENT_SEARCH_SUCCESS] (state, params) {
      console.log('PATIENT_SEARCH_SUCCESS')
      var data = params.data
      var reSearch = false

      if (data.meta && data.meta['re-search']) {
        reSearch = data.meta['re-search']
      }

      if (reSearch) {
        // 再検索
        state.patients = data.data
        if (data.meta['next-page'] === null) {
          // 次へのリンクが無かったら
          state.patientsNextPage = null
        }
      } else {
        // 通常検索
        if (data.meta && data.meta['current-page'] && data.meta['current-page'] > 1) {
          state.patients = state.patients.concat(data.data)
          state.patientsCurrentPage = data.meta['current-page']
        } else {
          state.patients = data.data
          state.patientsCurrentPage = 1
        }
        if (data.links && data.links['next']) {
          state.patientsNextPage = data.links['next']
        } else {
          state.patientsNextPage = null
        }
      }

      // 全体件数
      state.patientsTotalCount = 0
      if (data.meta && data.meta['total-count']) {
        state.patientsTotalCount = data.meta['total-count']
      }
      if (state.patientsTotalCount > 0) {
        state.patientsDataExists = true  // データあり
      } else {
        state.patientsDataExists = false // データなし
      }
      if (params.callback) {
        params.callback()
      }
    },
    [SET_PATIENT_SUCCESS] (state, data) {
      console.log('SET_PATIENT_SUCCESS')
      state.patient = data
      if (data.callback) {
        data.callback()
      }
    },
    [PATIENT_SHOW_FAILURE] (state, data) {
      console.log('PATIENT_SHOW_FAILURE')
      if (data.callback) {
        data.callback()
      }
    },
    [PATIENT_SHOW_SUCCESS] (state, params) {
      console.log('PATIENT_SHOW_SUCCESS')
      var data = params.data
      state.patient = data.data
      if (params.callback) {
        params.callback()
      }
    },
    [PATIENT_UPDATE_FAILURE] (state, data) {
      console.log('PATIENT_UPDATE_FAILURE')
      state.uploader.status = 'failure'
      state.uploader.errors.push(data.error)
    },
    [PATIENT_UPDATE_SUCCESS] (state, data) {
      console.log('PATIENT_UPDATE_SUCCESS')
      // console.log('data.data.id:' + data.data.id)
      state.uploader.status = 'success'

      for (var i = 0; i < state.patients.length; i++) {
        if (state.patients[i].id === data.data.id) {
          state.patients[i].attributes['avartar-path'] = data.data.attributes['avartar-path']
        }
      }
    },
    /** 選択フラグ更新成功 */
    [PATIENT_SET_SEL_FLAG_SUCCESS] (state, params) {
      console.log('PATIENT_SET_SEL_FLAG_SUCCESS')
      if (params.callback) {
        params.callback()
      }
    },
    /** 選択フラグ失敗 */
    [PATIENT_SET_SEL_FLAG_FAILURE] (state, params) {
      console.log('PATIENT_SET_SEL_FLAG_FAILURE')
      if (params.callback) {
        params.callback()
      }
    },
    [PATIENT_AVATAR_UPLOAD_FAILURE] (state, data) {
      console.log('PATIENT_AVATAR_UPLOAD_FAILURE')
      state.uploader.status = false
      state.uploader.errors.push(data.error)
    },
    [PATIENT_AVATAR_UPLOAD_SUCCESS] (state, data) {
      console.log('PATIENT_AVATAR_UPLOAD_SUCCESS')
      state.uploader.status = true
      if (data.callback !== null) {
        data.callback(data.data)
      }
    },
    [PATIENT_CLEAR] (state) {
      state.patients = []
    },
    [PATIENT_SHOW_CLEAR] (state) {
      state.patient = null
    },
    [PATIENT_SEARCH_PATIENT_CODE_FAILURE] (state, data) {
      console.log('PATIENT_SERARCH_PATIENT_CODE_FAILURE')
    },
    [PATIENT_SEARCH_PATIENT_CODE_SUCCESS] (state, data) {
      console.log('PATIENT_SEARCH_PATIENT_CODE_SUCCESS')
      state.patientCodeList = data.data.data
    },
    [PATIENT_NS_REMOVE_FAILURE] (state, data) {
      console.log('PATIENT_NS_REMOVE_FAILURE')
      // 通知
      state.notify = {
        danger: true,
        message_i18n: 'plan.nsips_delete_failure'
      }
      setTimeout(() => {
        state.notify = null
      }, constant.notifyShowTime.normal)
    },
    [PATIENT_NS_REMOVE_SUCCESS] (state, data) {
      console.log('PATIENT_NS_REMOVE_SUCCESS')
      // 通知
      state.notify = {
        success: true,
        message_i18n: 'plan.nsips_delete_success'
      }
      setTimeout(() => {
        state.notify = null
      }, constant.notifyShowTime.normal)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/patient.js